const LabeledInput = ({ label, value, type = "text" }) => (
  <div className="mb-3">
    <label className="form-label fw-bold text-secondary user-select-none">
      {label}
    </label>
    <input value={value} type={type} className="form-control" disabled />
  </div>
);

export default LabeledInput;
